import React from "react";

const ErrorPage = () => {
  return <div className="error-main-container">ErrorPage</div>;
};

export default ErrorPage;
